import fr_FR from "./fr_FR"
import nl_NL from "./nl_NL"
import en_US from "./en_US"
import test_localization from "./test_localization"

const localization: {[key:string]:any} = {
    test_localization,
    fr_FR,
	nl_NL,
	en_US
}
export default localization
